















































import { Vue, Component } from 'vue-property-decorator';
import Subtitle from '@/components/molecules/Typography/Subtitle.vue';
import Container from '@/components/atoms/Grid/Container.vue';
import Description from '@/components/molecules/Typography/Description.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { treatError } from '@/utils';
import eventBus from '@/utils/eventBus';
import FlagsService from '@/api/FlagsService';

@Component({
  components: {
    FilledButton,
    Description,
    Container,
    Subtitle,
    TextInput
  }
})
export default class NewFlagModal extends Vue {
  service = new FlagsService();

  loading = false;
  name = '';
  slug = '';
  slugPristine = true;

  changeName(value: string) {
    this.name = value;
    if (this.slugPristine) {
      this.generateSlug();
    }
  }

  changeSlug(value: string) {
    this.slug = this.slugify(value);
    this.slugPristine = false;
    if (!this.slug) {
      this.slugPristine = true;
      this.generateSlug();
    }
  }

  slugify(value: string) {
    return value
      .trim()
      .toLowerCase()
      .replace(/\[|\]/g, '')
      .replace(/[\W-]+/g, '-');
  }

  generateSlug() {
    this.slug = this.slugify(this.name);
  }

  async createNew() {
    try {
      this.loading = true;
      const ffUrl = this.service.createFlagDownloadUrl({
        name: this.name,
        slug: this.slug
      });
      window.open(ffUrl, '_blank');

      this.$notification('Success');
      this.closeModal();
    } catch (e) {
      this.$notification(treatError(e));
    } finally {
      this.loading = false;
    }
  }

  closeModal() {
    eventBus.$emit('setSideModalVisible', false);
  }
}
